import { BlogType } from '../../types/blog.types';

export const blogsAddInitialState = {
  metaTitle: '',
  metaContent: '',
  urlPath: '',
  content: '',
  imageUrl: '',
  title: '',
  shortText: '',
};

// What a post can be. A case study is listed on vgrubs.com/case-studies and
// gets the client and highlights fields.
export const BLOG_TYPE_OPTIONS: { value: BlogType; name: string }[] = [
  { value: 'blog', name: 'Blog' },
  { value: 'caseStudy', name: 'Case study' },
];

// The list's tabs: everything, or one type.
export type BlogListTab = BlogType | 'all';

export const BLOG_LIST_TABS: { tab: BlogListTab; name: string }[] = [
  { tab: 'all', name: 'All' },
  { tab: 'blog', name: 'Blogs' },
  { tab: 'caseStudy', name: 'Case Studies' },
];

// The backend answers 400 past three.
export const MAX_BLOG_HIGHLIGHTS = 3;
